/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      // Service worker ready
    },
    registered() {
      // Service worker registered
    },
    cached() {
      // Content cached
    },
    updatefound() {
      // New content downloading
    },
    updated() {
      // New content available
    },
    offline() {
      // Offline mode
    },
    error() {
      // Service worker error
    },
  })
}
